import React from "react";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  size?: "sm" | "md" | "lg" | number; // dynamic size option
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, size = "md" }) => {
  // Default size mapping
  const sizeMap: Record<string, { width: number; height: number }> = {
    sm: { width: 36, height: 24 },
    md: { width: 56, height: 28 },
    lg: { width: 72, height: 36 },
  };

  // Get dimensions
  const { width, height } =
    typeof size === "number" ? { width: size * 2, height: size } : sizeMap[size];

  // Knob should be slightly smaller than height
  const knob = height - 4;
  // Translate distance = track width - knob - padding (2px each side)
  const translate = width - knob - 4;

  return (
    <button
      type="button"
      onClick={onChange}
      className={`relative rounded-full transition-colors duration-300 focus:outline-none ${
        checked ? "bg-primaryButton" : "bg-gray-300"
      }`}
      style={{ width, height }}
    >
      <span
        className="absolute bg-white rounded-full shadow-md transform transition-transform duration-300"
        style={{
          width: knob,
          height: knob,
          top: 2,
          left: 2,
          transform: checked ? `translateX(${translate}px)` : "translateX(0px)",
        }}
      />
    </button>
  );
};

export default ToggleSwitch;
